import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-pakistan-green">
            About Yakjehti Pakistan
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Building bridges, creating opportunities, and fostering unity across Pakistan since 2025.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-3xl font-bold mb-6 text-pakistan-green">Our Mission</h2>
            <p className="text-lg text-gray-700 mb-4">
              Yakjehti Pakistan Welfare Society was founded with a vision to create sustainable economic 
              growth and social welfare across Pakistan. We believe in the power of unity (Yakjehti) to 
              transform communities and build a prosperous future for all Pakistanis.
            </p>
            <p className="text-lg text-gray-700 mb-4">
              Through our manufacturing initiatives, welfare programs, and community outreach, we aim to:
            </p>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-center">
                <span className="text-green-600 mr-3">•</span>
                Create sustainable employment opportunities
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-3">•</span>
                Provide quality education and healthcare
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-3">•</span>
                Foster unity among diverse communities
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-3">•</span>
                Support economic development across provinces
              </li>
            </ul>
          </div>
          <div className="bg-gradient-to-r from-green-400 to-green-600 rounded-lg p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Vision 2025-2030</h3>
            <p className="mb-4">
              By 2030, we envision Pakistan as a unified nation with:
            </p>
            <ul className="space-y-2">
              <li>• 50,000+ jobs created through our manufacturing programs</li>
              <li>• 100+ community centers across all provinces</li>
              <li>• Comprehensive healthcare access in rural areas</li>
              <li>• Skills training for 250,000+ individuals</li>
            </ul>
          </div>
        </div>

        <div className="text-center">
          <h2 className="text-3xl font-bold mb-8 text-pakistan-green">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl mb-4">🤝</div>
              <h3 className="text-xl font-bold mb-2">Unity</h3>
              <p className="text-gray-600">Bringing people together across all backgrounds</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">🔧</div>
              <h3 className="text-xl font-bold mb-2">Innovation</h3>
              <p className="text-gray-600">Modern solutions for traditional challenges</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">🌱</div>
              <h3 className="text-xl font-bold mb-2">Sustainability</h3>
              <p className="text-gray-600">Building for long-term positive impact</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">❤️</div>
              <h3 className="text-xl font-bold mb-2">Compassion</h3>
              <p className="text-gray-600">Serving humanity with dedication and care</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
